module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('afstereo-dashboard', {
    attrs: {
      "selectedDate": _vm.selectedDate,
      "selectedPeriod": _vm.selectedPeriod,
      "selectedStation": _vm.selectedStation,
      "chartsData": _vm.chartsData,
      "stations": _vm.stations,
      "pluginEnabled": _vm.isPluginEnabled('app.dashboard.afstereo')
    },
    on: {
      "previous": function($event) {
        return _vm.handlePrevious($event)
      },
      "next": function($event) {
        return _vm.handleNext($event)
      },
      "changePeriod": function($event) {
        return _vm.handleChangePeriod($event)
      },
      "changeStation": function($event) {
        return _vm.handleChangeStation($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b3fca85","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/analytics/AfstereoContainer.vue
// module id = 3351
// module chunks = 3